import React, { useMemo } from "react";
import ProptTypes from "prop-types";
import { Module } from "../../components";
import { redirects } from "../../config";
import { applyKey } from "../../utils";
import { HomePage } from "./pages";

const RedirectPage = ({ para }) => {
  window.location.href = para;
  return null;
};

RedirectPage.propTypes = {
  para: ProptTypes.string.isRequired,
};

const Consorcio = () => {
  const pdfRoutes = useMemo(
    () =>
      applyKey(redirects, ([de, para]) => (
        <Module.Page
          path={de.replace("/paravoce/consorcios", "")}
          page={RedirectPage}
          title="pdf redirecionado"
          description="Fique por dentro das vantagens e caracterísiticas que nossos consórcios oferecem"
          disableNavigation
          para={para}
        />
      )),
    []
  );

  return (
    <Module moduleName="Consórcios">
      {pdfRoutes}
      <Module.Page path="*" page={HomePage} title="Página inicial" />
    </Module>
  );
};

Consorcio.propTypes = {};

export default Consorcio;
